import React, { Component, Fragment } from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { slideSlick } from "./script";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiUsers, FiAward, FiBookOpen, FiHome, FiPhone, FiMail, FiInfo, FiArrowRight } from "react-icons/fi";
import { FaInstagram, FaLine } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ShortcutMenu from "../component/HomeLayout/homeOne/ShortcutMenu";

import { portfolioSlick2 } from "./script";

const Portfolio_image2 = <img src="/assets/images/singha/floor1/IMG_7802.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image3 = <img src="/assets/images/singha/floor1/IMG_7809.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image5 = <img src="/assets/images/singha/floor1/IMG_7820.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image9 = <img src="/assets/images/singha/floor1/IMG_7830.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image10 = <img src="/assets/images/singha/floor1/IMG_7833.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image17 = <img src="/assets/images/singha/floor1/IMG_7851.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image18 = <img src="/assets/images/singha/floor1/IMG_7852.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image25 = <img src="/assets/images/singha/floor2/IMG_7917.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image28 = <img src="/assets/images/singha/floor2/IMG_7934.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image29 = <img src="/assets/images/singha/floor2/IMG_7941.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image30 = <img src="/assets/images/singha/floor2/IMG_7952.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image31 = <img src="/assets/images/singha/floor2/IMG_7963.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image32 = <img src="/assets/images/singha/floor2/IMG_7975.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image33 = <img src="/assets/images/singha/floor2/IMG_7982.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image34 = <img src="/assets/images/singha/floor2/IMG_7984.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image35 = <img src="/assets/images/singha/floor2/IMG_7990.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image36 = <img src="/assets/images/singha/floor2/IMG_7997.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image38 = <img src="/assets/images/singha/floor2/IMG_8001.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image40 = <img src="/assets/images/singha/floor2/IMG_8051.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image41 = <img src="/assets/images/singha/floor2/IMG_8058.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image42 = <img src="/assets/images/singha/floor2/IMG_8100.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image43 = <img src="/assets/images/singha/floor2/IMG_8107.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image44 = <img src="/assets/images/singha/floor2/IMG_8110.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image45 = <img src="/assets/images/singha/floor2/IMG_8129.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image46 = <img src="/assets/images/singha/floor2/IMG_8155.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image47 = <img src="/assets/images/singha/floor2/IMG_8161.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image49 = <img src="/assets/images/singha/floor2/IMG_8195.webp" alt="กิจกรรมที่พิพิธภัณฑ์สิงห์ท่า" />;

// LINE_ALBUM images from screen directory
const Portfolio_image50 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.5.18_250730_1.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image51 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.5.18_250730_3.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image52 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_1.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image53 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_2.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image54 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_3.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image55 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_5.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image56 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_6.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;
const Portfolio_image57 = <img src="/assets/images/singha/screen/LINE_ALBUM_2025.7.15_250715_18.jpg" alt="กิจกรรมพิพิธภัณฑ์สิงห์ท่า" />;

const PortfolioList2 = [
    { image: Portfolio_image2, },
    { image: Portfolio_image3, },
    { image: Portfolio_image5, },
    { image: Portfolio_image9, },
    { image: Portfolio_image10, },
    { image: Portfolio_image17, },
    { image: Portfolio_image18, },
    { image: Portfolio_image25, },
    { image: Portfolio_image28, },
    { image: Portfolio_image29, },
    { image: Portfolio_image30, },
    { image: Portfolio_image31, },
    { image: Portfolio_image32, },
    { image: Portfolio_image33, },
    { image: Portfolio_image34, },
    { image: Portfolio_image35, },
    { image: Portfolio_image36, },
    { image: Portfolio_image38, },
    { image: Portfolio_image40, },
    { image: Portfolio_image41, },
    { image: Portfolio_image42, },
    { image: Portfolio_image43, },
    { image: Portfolio_image44, },
    { image: Portfolio_image45, },
    { image: Portfolio_image46, },
    { image: Portfolio_image47, },
    { image: Portfolio_image49, },
    { image: Portfolio_image50, },
    { image: Portfolio_image51, },
    { image: Portfolio_image52, },
    { image: Portfolio_image53, },
    { image: Portfolio_image54, },
    { image: Portfolio_image55, },
    { image: Portfolio_image56, },
    { image: Portfolio_image57, },
]

class Startup extends Component {
    static defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };
    render() {
        return (
            <Fragment>
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/assets/images/singha/floor1/IMG_7829.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '80vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '4rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1.5rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    ยินดีต้อนรับเข้าสู่<br />
                                    พิพิธภัณฑ์สิงห์ท่า
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.3rem',
                                    opacity: 0.9,
                                    marginBottom: '2rem',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                    lineHeight: '1.6'
                                }}>
                                    ศูนย์เรียนรู้ประวัติศาสตร์และวิถีชีวิตชุมชนเมืองเก่าบ้านสิงห์ท่า<br />
                                    จังหวัดยโสธร
                                </p>
                                <div className="hero-buttons" style={{
                                    display: 'flex',
                                    gap: '1rem',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap'
                                }}>
                                    <Link to="/about" style={{
                                        backgroundColor: '#F45354',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        boxShadow: '0 4px 15px rgba(244, 83, 84, 0.3)'
                                    }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 20px rgba(244, 83, 84, 0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 15px rgba(244, 83, 84, 0.3)';
                                        }}>
                                        เรียนรู้เพิ่มเติม
                                        <FiArrowRight />
                                    </Link>
                                    <Link to="/contact" style={{
                                        backgroundColor: 'transparent',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        border: '2px solid white',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '0.5rem'
                                    }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                            e.target.style.color = '#242424';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = 'white';
                                        }}>
                                        ติดต่อเรา
                                        <FiPhone />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Welcome Section */}
                <div className="welcome-section ptb--80" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="welcome-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        ยินดีต้อนรับเข้าสู่ พิพิธภัณฑ์สิงห์ท่า
                                    </h2>
                                    <p className="description" style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                    }}>
                                        พิพิธภัณฑ์สิงห์ท่า ก่อตั้งขึ้นเพื่อรวบรวมและเผยแพร่เรื่องราวของชุมชนสิงห์ท่า จัดแสดงนิทรรศการทางประวัติศาสตร์และวิถีชีวิตพื้นถิ่น พร้อมกิจกรรมให้ความรู้แก่ผู้เยี่ยมชมตลอดปี
                                        แนวคิดของการจัดนิทรรศการภายในพิพิธภัณฑ์ เป็นการนำเสนอประวัติศาสตร์ของเมืองเก่าบ้านสิงห์ท่าผ่านการค้าขายและร้านค้า เนื่องจากในอดีตบริเวณนี้เป็นย่านการค้า มีความเจริญรุ่งเรืองและเปลี่ยนแปลงผ่านกาลเวลา ทำให้การเล่าเรื่องมีความน่าสนใจ นอกจากนี้ ร้านค้าและสถานที่ต่างๆ ที่ปรากฏในพิพิธภัณฑ์ ก็ยังทำการค้าขายและดำเนินการอยู่ในปัจจุบัน หลังจากเยี่ยมชมพิพิธภัณฑ์แล้ว ยังสามารถออกไปเยี่ยมชมสถานที่จริงในบริเวณเมืองเก่าบ้านสิงห์ท่าได้อีกด้วย
                                       </p>
                                    <p className="description" style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                        marginBottom: '2rem'
                                    }}>
                                        พิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า ได้มีการเปลี่ยนชื่อเรียกให้สั้นลงเป็น พิพิธภัณฑ์สิงห์ท่า หรือ สิงห์ท่ามิวเซียม เพื่อให้กระชับและเป็นสากลมากขึ้น นอกจากนี้ยังสื่อให้เห็นถึงรูปแบบการเล่าเรื่องประวัติศาสตร์ที่มีความทันสมัย เป็นแหล่งเรียนรู้ทางประวัติศาสตร์สำหรับชาวเมืองยโสธร และเป็นแหล่งท่องเที่ยวเชิงประวัติศาสตร์สำหรับผู้มาเยือน</p>
                                    <div className="welcome-stats" style={{
                                        display: 'flex',
                                        gap: '2rem',
                                        flexWrap: 'wrap'
                                    }}>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                200+
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ปี ประวัติศาสตร์
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                2
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ชั้น นิทรรศการ
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                9
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1 rem'
                                            }}>
                                                ส่วนจัดแสดง
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="welcome-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="assets/images/singha/out/LINE_ALBUM_2025.7.15_250715_18.jpg" alt="สิงห์ท่า" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Floor 1 Exhibition */}
                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 1
                                    </h2>
                                    <div className="exhibition-details">
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                ส่วนจัดแสดงที่ 1 : เรื่องเล่าเมืองสิงห์ท่า
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                นิทรรศการหมุนเวียน เรื่องเล่าเมืองสิงห์ท่า ร่วมค้นหาความหมายของคำว่า สิงห์ท่า และตำนานสิงห์คู่ ที่เป็นต้นกำเนิดของชุมชนในยุคก่อบ้านตั้งเมืองจนถึงการยกบ้านสิงห์ท่าขึ้นเป็นเมืองยศสุนทร ในปี พ.ศ. 2357 และกลายเป็นจังหวัดยโสธร จังหวัดที่ 71 ของประเทศไทย
                                            </p>
                                        </div>
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                ส่วนจัดแสดงที่ 2 : สิงห์ท่าในความคิดถึง
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                จำลองบรรยากาศโรงภาพยนตร์แห่งแรกของจังหวัดยโสธร "ยโสธรภาพยนตร์" ที่ตั้งอยู่ภายในพื้นที่ชุมชน พร้อมฉายภาพยนตร์สารคดีสั้น "สิงห์ท่าในความคิดถึง" เรื่องราวมนต์เสน่ห์ของเมืองเก่าเล่าผ่านผู้อาวุโสในชุมชน โอบล้อมไปด้วยความคิดถึงจากวันวาน
                                            </p>
                                        </div>
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                ส่วนจัดแสดงที่ 3 : ลัดเลาะรอบเมือง
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                ทำความรู้จักพื้นที่ชุมชนบ้านสิงห์ท่าผ่าน Mapping Interactive ใน 3 หัวข้อเรื่องได้แก่ รู้จักสิงห์ท่า, แผนที่พัฒนาเมืองและปักหมุดสิงห์ท่าเพื่อให้ผู้เข้าชมได้ทำความรู้จักพื้นที่ชุมชนบ้านสิงห์ท่าในทุกแง่มุม
                                            </p>
                                        </div>
                                        <div className="exhibition-item" style={{
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                ส่วนจัดแสดงที่ 4 : สิงห์ท่าค้าขาย
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                เพื่อให้เข้าถึงเอกลักษณ์ของชุมชนศูนย์กลางการค้าขายกันมาตั้งแต่อดีต ผู้เข้าชมสามารถซื้อหาของที่ระลึกของพิพิธภัณฑ์สิงห์ท่าและสินค้าจากชุมชนในจังหวัดยโสธร รวมไปถึงประสบการณ์ซื้อสินค้าจากอดีตในรูปแบบการ Shoping Online เพื่อเช่ื่อมต่อโลกอดีตและโลกปัจจุบันที่นิทรรศการชั้น 2
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7829.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                                <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7841.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7880.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                                <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor1/IMG_7802.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div> */}

                {/* Floor 2 Exhibition - Part 1 */}
                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2 
                                    </h2>
                                    <div className="exhibition-details">
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                               ส่วนจัดแสดงที่ 5.1 : ห้วงวิถีชีวิต
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                   
                                                    ภาพรวมสังคมในยุคแรกเริ่ม ชาวบ้านดำรงชีวิตในสังคมการเกษตร เลี้ยงสัตว์ ใช้ชีวิตพึ่งพิงอยู่กับแม่น้ำชี แม่น้ำสายหลักที่หล่อเลี้ยงชีวิตคนในชุมชนและสำคัญต่อการพัฒนาความเจริญมาสู่บ้านสิงห์ท่า ส่งผลต่อวิถีชีวิตอย่างมากในช่วงเวลาต่อมา
                                            </p>
                                        </div>
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                               ส่วนจัดแสดงที่ 5.2 : ความเชื่อพื้นถิ่น
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                 ชุมชนบ้านสิงห์ท่ามีโครงสร้างที่ผูกพันกับความเชื่อทางด้านศาสนาและสิ่งศักดิ์สิทธิ์ ความเชื่อเหล่านี้มีอิทธิพลต่อวิถีชีวิตที่แสดงออกมาในรูปแบบประเพณีและพิธีกรรมต่าง ๆ เป็นการผสมผสานความศรัทธาทางศาสนาเข้ากับความเชื่อเรื่องสิ่งศักดิ์สิทธิ์
                                            </p>
                                        </div>
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                               ส่วนจัดแสดงที่ 5.3 : สายน้ำแห่งโอกาส
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                    แม่น้ำชี แม่น้ำสำคัญที่หล่อเลี้ยงชีวิตคนในชุมชนบ้านสิงห์ท่า ความผูกพันระหว่างคนกับแม่น้ำชีเป็นปัจจัยสำคัญในการพัฒนาชุมชน อีกทั้งเป็นเส้นทางคมนาคมที่นำความเจริญมาสู่บ้านสิงห์ท่าในยุคการค้าในอดีต                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/IMG_7934.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                                 <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/IMG_7949.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                                <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/IMG_7954.webp" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Floor 2 Exhibition - Part 2 */}
                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-12 mb-4">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/6.1.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 6" />
                                </div>
                                 <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/6.2.jpg" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12 mb-4">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/6.3.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 6" />
                                </div>
                                 <div className="exhibition-image" style={{
                                    marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/6.4.jpg" alt="ประวัติพิพิธภัณฑ์สิงห์ท่า" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2
                                    </h2>
                                    
                                    <div className="exhibition-details">

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 6.1 : คนต่างถิ่น
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  เมื่อคนต่างถิ่นเข้ามาค้าขายและตั้งรกรากในบ้านสิงห์ท่า รูปแบบวิถีชีวิตของชุมชนเกิดความหลากหลายและในที่สุดก็ผสมผสานเป็นรูปแบบของชุมชนในปัจจุบัน                                            
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 6.2 ค้าขายกับโคราช
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  เมื่อคนต่างถิ่นเข้ามาค้าขายและตั้งรกรากในบ้านสิงห์ท่า รูปแบบวิถีชีวิตของชุมชนเกิดความหลากหลายและในที่สุดก็ผสมผสานเป็นรูปแบบของชุมชนในปัจจุบัน                                            
                                                  </p>
                                        </div>

                                
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 6.3 : พื้นที่ชีวิต
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  คนต่างถิ่นเข้ามาตั้งรกรากในชุมชนบ้านสิงห์ท่าส่งผลให้เกิดการผสมผสานทางวัฒนธรรมขึ้น เกิดวิถีชีวิตที่หลากหลาย ทั้งด้านครอบครัว ที่อยู่อาศัย และวัฒนธรรมที่หลอมรวมกันอย่างแน่นแฟ้น เป็นรากฐานที่สืบทอดจากรุ่นสู่รุ่น                                            
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 6.4 : กิน อยู่ คือ
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  วัฒนธรรมการกินของชาวสิงห์ท่าสะท้อนภูมิปัญญาการดำรงชีวิตและวิวัฒนาการทางวัฒนธรรมของชุมชนอย่างชัดเจน อาหารแต่ละจานแสดงให้เห็นถึงประวัติศาสตร์และวิถีชีวิตความเป็นอยู่ของชุมชน                                            
                                                  </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Floor 2 Exhibition - Part 3 */}
                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2
                                    </h2>
                                    <div className="exhibition-details">
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 7.1 : นานาร้านรวง
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                 เมื่อความเป็นอยู่ในชุมชนเริ่มมั่นคงถาวร พ่อค้าชาวจีนได้ใช้พื้นที่สร้างตลาดและย่านการค้า ส่งผลให้ชุมชนเปลี่ยนเป็นศูนย์กลางการค้า มีผู้คนหลั่งไหลเข้ามาทำให้เศรษฐกิจเติบโตและชุมชนขยายตัวขึ้น                                            
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 7.2 : ค้าขายอุบลราชธานี
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                สยามประเทศเร่งพัฒนาระบบสื่อสารและคมนาคมกับภาคอีสาน การค้าขายระหว่างบ้านสิงห์ท่ากับอุบลราชธานีจึงเติบโตขึ้น ควบคู่กับการมาถึงของรถไฟในหัวเมืองอีสาน                                            
                                                  </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="exhibition-image" style={{
                                      marginTop:'30px',
                                      borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/7.1_1.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                                <div className="exhibition-image" style={{
                                     marginTop:'30px',
                                     borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/7.2.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row align-items-center">

                        <div className="col-lg-6 col-md-12">
                                <div className="exhibition-image" style={{
                                     marginTop:'30px',
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/8.1.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                                <div className="exhibition-image" style={{
                                      marginTop:'30px',
                                      borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/8.2.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2
                                    </h2>
                                    <div className="exhibition-details">
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 8.1 : ธุรกิจใหม่
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  การขยายตัวทางการค้าตามความต้องการของผู้บริโภคส่งผลให้เกิดธุรกิจใหม่ ๆ ภายในชุมชนบ้านสิงห์ท่า ร้านค้าทันสมัยและสถานบันเทิงได้ถือกำเนิดเพื่อดึงดูดผู้คนจากภายนอกเข้ามาในชุมชนมากขึ้น                                            
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 8.2 : สินค้าสมัยนิยม
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                  ความต้องการของผู้บริโภคขยายตัวตามช่องทางสื่อสารที่ทันสมัยมีส่วนสำคัญในการเปลี่ยนแปลงวิถีชีวิตและเศรษฐกิจของชุมชนบ้านสิงห์ท่า ส่งผลเกิดความหลากหลายในสินค้าและบริการที่มีอยู่ในพื้นที่                                          
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 8.3 : ไลฟ์สไตล์แห่งยุค
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                 ยุคที่บ้านสิงห์ท่าเจริญรุ่งเรืองเป็นช่วงเวลาแห่งการเปลี่ยนแปลงที่สำคัญ การใช้ชีวิตของคนในชุมชนเป็นอย่างไรท่ามกลางยุคสมัยของการพัฒนาพื้นที่ให้ทันต่อโลก                                          
                                                  </p>
                                        </div>
                                     
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div> */}

                {/* <div className="exhibition-section ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2
                                    </h2>
                                   
                                    <div className="exhibition-details">
                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 9.1 : กาลเวลาผันผ่าน
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                                 การขยายตัวของชุมชนบ้านสิงห์ท่าทำให้ผู้คนย้ายถิ่นฐานไปสร้างบ้านเรือนรอบนอก พ่อค้าย้ายออกไปสู่ฝั่งเมืองใหม่ ส่งผลให้ตลาดหลักเมืองลดบทบาทศูนย์กลางการค้าลงเหลือเพียงร่องรอยความรุ่งเรืองในอดีต                                            
                                                  </p>
                                        </div>

                                        <div className="exhibition-item" style={{
                                            marginBottom: '1.5rem',
                                            padding: '1.5rem',
                                            backgroundColor: 'white',
                                            borderRadius: '15px',
                                            boxShadow: '0 5px 15px rgba(0,0,0,0.08)'
                                        }}>
                                            <h4 style={{
                                                fontSize: '2 rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                 ส่วนจัดแสดงที่ 9.2 : ห้วงเวลาปัจจุบัน
                                            </h4>
                                            <p style={{
                                                color: '#666',
                                                lineHeight: '1.6',
                                                margin: 0,
                                                fontSize: '1.2rem'
                                            }}>
                                               ชุมชนบ้านสิงห์ท่าในปัจจุบันยังคงมีร่องรอยความเจริญรุ่งเรืองในอดีตให้เห็นทั้งด้านสถาปัตยกรรมและวิถีชีวิตของผู้คน แม้ว่าความคึกคักทางการค้าจะลดลงไปแต่บรรยากาศของชุมชนที่เต็มไปด้วยเรื่องราวทางประวัติศาสตร์ยังคงอยู่                                         
                                                  </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                            <div className="exhibition-image" style={{
                                      marginTop:'30px',
                                      borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/9.1.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                            <div className="exhibition-image" style={{
                                      marginTop:'30px',
                                      borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/9.2.jpg" alt="นิทรรศการชั้น 2 ส่วนจัดแสดงที่ 8" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Gallery Section */}
                <div className="gallery-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ภาพรวมพิพิธภัณฑ์สิงห์ท่า
                                    </h2>
                                    <p style={{
                                        color: '#666',
                                        fontSize: '1.5rem',
                                        maxWidth: '600px',
                                        margin: '0 auto'
                                    }}>
                                        ชมภาพบรรยากาศและกิจกรรมต่างๆ ภายในพิพิธภัณฑ์สิงห์ท่า
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="gallery-wrapper" style={{
                            backgroundColor: 'white',
                            padding: '3rem',
                            borderRadius: '20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                        }}>
                            <div className="wrapper sacousel-inner mb--55">
                                <div className="slick-activation mt--30 mt_sm--30">
                                    <Slider {...portfolioSlick2}>
                                        {PortfolioList2.map((value, index) => (
                                            <div className="im_portfolio" key={index}>
                                                <div className="thumbnail_inner">
                                                    <div className="thumbnail" style={{
                                                        borderRadius: '15px',
                                                        overflow: 'hidden',
                                                        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
                                                        transition: 'transform 0.3s ease'
                                                    }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.transform = 'scale(1.05)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.transform = 'scale(1)';
                                                        }}>
                                                        {value.image}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Call to Action Section */}
                {/* <div className="cta-section ptb--50" style={{ backgroundColor: '#242424' }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 style={{
                                    color: 'white',
                                    fontSize: '2.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1.5rem'
                                }}>
                                    เยี่ยมชมพิพิธภัณฑ์สิงห์ท่า
                                </h2>
                                <p style={{
                                    color: '#ccc',
                                    fontSize: '1.5rem',
                                    marginBottom: '2rem',
                                    lineHeight: '1.6'
                                }}>
                                    เปิดให้เข้าชมทุกวันอังคาร-อาทิตย์ เวลา 9.00-16.30 น.<br />
                                    ค่าเข้าชมเพียง 20 บาท สำหรับชาวไทย
                                </p>
                                <div style={{
                                    display: 'flex',
                                    gap: '1rem',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap'
                                }}>
                                    <Link to="/contact" style={{
                                        backgroundColor: '#F45354',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '0.5rem'
                                    }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 20px rgba(244, 83, 84, 0.4)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = 'none';
                                        }}>
                                        ติดต่อจองเข้าชม
                                        <FiArrowRight />
                                    </Link>
                                    <Link to="/about" style={{
                                        backgroundColor: 'transparent',
                                        color: 'white',
                                        padding: '1rem 2rem',
                                        borderRadius: '50px',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '1.5rem',
                                        border: '2px solid white',
                                        transition: 'all 0.3s ease'
                                    }}
                                        onMouseEnter={(e) => {
                                            e.target.style.backgroundColor = 'white';
                                            e.target.style.color = '#242424';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = 'white';
                                        }}>
                                        เรียนรู้เพิ่มเติม
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </Fragment >
        )
    }
}
export default Startup;